import React from 'react';
import { Link } from 'react-router-dom';

import { cn } from 'helpers/classnames';
import TrackingProgress from 'components/account/TrackingProgress';
import OrderStatus from 'components/account/OrderStatus';

import { hasShipmentBeenDelivered, hasShipmentBeenShipped } from '/helpers/MyAccountUtils';

import useMartyContext from 'hooks/useMartyContext';

import css from 'styles/components/account/shippingStatus.scss';

const shipmentMessageFallBack = 'Track this shipment';
export const ShippingStatus = ({
  orderId,
  shipmentId,
  status,
  onShipmentClick = f => f,
  currentShipmentNumber,
  totalShipments,
  shipmentMessage,
  trackingAvailable,
  setToolTipVisibilityforMobile,
  hideTrackingProgress = false,
  className,
  planName
}) => {
  const { testId } = useMartyContext();

  if (!status) {
    return null;
  }

  const isShipped = hasShipmentBeenShipped(status);
  const isDelivered = hasShipmentBeenDelivered(status);
  const displayTrackingProgress = !hideTrackingProgress && (isShipped || isDelivered);

  return (
    <div className={cn(css.shippingStatusContainer, className)} data-test-id={testId('shippingStatus')}>
      <OrderStatus setToolTipVisibilityforMobile={setToolTipVisibilityforMobile} status={status} planName={planName} />
      {currentShipmentNumber > 0 && totalShipments > 0 && (
        <p className={css.shipmentNumber}>{`Shipment ${currentShipmentNumber} of ${totalShipments}`}</p>
      )}
      {trackingAvailable
        ? orderId &&
          shipmentId && (
            <Link onClick={onShipmentClick} className={css.shipmentMessage} to={`/shipments/${orderId}/${shipmentId}`}>
              {shipmentMessage || shipmentMessageFallBack}
            </Link>
          )
        : !!shipmentMessage && <p className={css.shipmentMessage}>{shipmentMessage}</p>}
      {displayTrackingProgress && (
        <div className={css.trackingProgressContainer}>
          <TrackingProgress isShipped={isShipped} isDelivered={isDelivered} />
        </div>
      )}
    </div>
  );
};

export default ShippingStatus;
